import type { HTMLAttributes } from 'react'

import { Button, StackIcon } from 'shared/ui'

import css from './NotExistYet.module.scss'

export const NotExistYet = ({
	onOpen,
	...props
}: HTMLAttributes<HTMLElement> & {
	onOpen: () => void
}) => (
	<article className={css.root} {...props}>
		<h1 className={css.headline}>
			5 minutes guide on how to&nbsp;launch your first campaign
		</h1>

		<iframe
			allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; allowfullscreen'
			// @ts-expect-error
			allowfullscreen='allowfullscreen'
			className={css.video}
			frameBorder={0}
			height={400}
			referrerPolicy='strict-origin-when-cross-origin'
			src='https://www.youtube.com/embed/2pn8AYJVCCo'
			title='YouTube video player'
			width={712}
		/>

		<Button onClick={onOpen} typography={css.action}>
			<StackIcon icon='export' />
			Add contacts
		</Button>
	</article>
)
